import React, { memo, useMemo, useEffect, useState } from "react";
import "../../../assets/scss/themes.scss";
import { configureStore } from "../../../store/messenger/store";
import { Provider } from "react-redux";
import "./index.css";
import Layout from "../Chats/Layout";
import Videocall from "./Videocall";
import { useCallContext } from "../../../store/context/CallProvider";
import { useSocket } from "../../../store/context/SocketProvider";
import { useSelector, useDispatch } from "react-redux";
import {
  updateMessages,
  deleteMessage,
  updateContacts,
  updateConversations,
  deleteContacts,
} from "../../../store/messengerSlice";
import SimpleBar from "simplebar-react";
import ChatInput from "./ChatInputs";
import Header from "./HeaderTop";
import { Row, Col } from "reactstrap";

const VideocallIndex = memo(() => {
  const dispatch = useDispatch();
  const messenger = useSelector((state) => state.messenger);
  const { me } = useSocket();

  const [isChat, setChat] = useState(false);
  const [isDrag, setDrag] = useState(false);
  const [messages, setMessages] = useState([
    {
      id: 1,
      message: 'hello',
      time: "00:00",
      userType: "sender",
      image: null,
      isFileMessage: false,
      isImageMessage: false
    },
    {
      id: 1,
      message: 'hey, AI chatbot here',
      time: "00:00",
      userType: "AI",
      image: null,
      isFileMessage: false,
      isImageMessage: false
    }
  ])

  // Call context props
  const {
    remoteUser,
    localStream,
    remoteStream,
    closeCall,
    startVideo,
    stopVideo,
    toggleMute,
    isVideoTrack,
    isMuted,
    isVideo,
  } = useCallContext();

  // Memoize streams using JSON.stringify for MediaStream comparison
  const stableLocalStream = useMemo(() => localStream, [
    JSON.stringify(localStream?.getTracks().map(t => t.id))
  ]);

  const stableRemoteStream = useMemo(() => remoteStream, [
    JSON.stringify(remoteStream?.getTracks().map(t => t.id))
  ]);

  // Memoize dispatch functions
  const messengerActions = useMemo(() => ({
    setMessages: (obj) => dispatch(updateMessages({
      key: messenger.activeUser,
      message: obj,
    })),
    deleteMessage: (id) => dispatch(deleteMessage({ id })),
    updateContacts: (cntcts) => dispatch(updateContacts(cntcts)),
    updateConversations: (data) => dispatch(updateConversations([data])),
    deleteConversation: (id) => dispatch(deleteContacts(id))
  }), [dispatch, messenger.activeUser]);

  // Debug remote stream
  useEffect(() => {
    if (stableRemoteStream) {
      console.log('Remote stream updated:', {
        id: stableRemoteStream.id,
        active: stableRemoteStream.active,
        tracks: stableRemoteStream.getTracks().map(t => ({
          id: t.id,
          kind: t.kind,
          readyState: t.readyState,
          enabled: t.enabled,
          muted: t.muted
        }))
      });
    }
  }, [stableRemoteStream]);

  const addMessage = (message, type) => {
    var messageObj = null;

    let d = new Date();
    var n = d.getSeconds();

    //matches the message type is text, file or image, and create object according to it
    switch (type) {
      case "textMessage":
        messageObj = {
          id: messages.length + 1,
          message: message,
          time: "00:" + n,
          userType: "sender",
          image: null,
          isFileMessage: false,
          isImageMessage: false
        }
        break;

      case "fileMessage":
        messageObj = {
          id: messages.length + 1,
          message: 'file',
          fileMessage: message.name,
          size: message.size,
          time: "00:" + n,
          userType: "sender",
          image: null,
          isFileMessage: true,
          isImageMessage: false
        }
        break;

      case "imageMessage":
        var imageMessage = [
          { image: message },
        ]

        messageObj = {
          id: messages.length + 1,
          message: 'image',
          imageMessage: imageMessage,
          size: message.size,
          time: "00:" + n,
          userType: "sender",
          image: null,
          isImageMessage: true,
          isFileMessage: false
        }
        break;

      default:
        break;
    }
    // setMsg((prev) => prev = '')       
    setMessages([...messages, messageObj]);
  }

  const chatHandler = () => {
    setChat(!isChat);
  }

  return (
    <Provider store={configureStore()}>
      <Row className="g-1 mt-2 position-relative video-call-container">
        <Col lg={8} className="col-xxl-8 col-md-8 col-12 p-0">
          <Videocall
            currentUser={me}
            remoteUser={remoteUser}
            localStream={stableLocalStream}
            remoteStream={stableRemoteStream}
            closeCall={closeCall}
            startVideo={startVideo}
            stopVideo={stopVideo}
            toggleMute={toggleMute}
            isVideoTrack={isVideoTrack}
            isMuted={isMuted}
            isVideo={isVideo}
            chatHandler={chatHandler}
          />
        </Col>

        <Col lg={4} className={`col-xxl-4 col-md-4 col-12 p-0 user-chat h-100 border-start  ${isChat && "user-chat-show"}`}>
            <div className="w-100 position-relative h-100">
              <Header text="Chat" handler={chatHandler} />

              <SimpleBar
                style={{ maxHeight: "100%" }}
                className="chat-conversation p-3 p-lg-4"
                id="messages">
                <ul className="list-unstyled mb-0">
                  {
                    messages.map((msg, key) =>
                      // chat.isToday && chat.isToday === true ? <li key={"dayTitle" + key}>
                      //     <div className="chat-day-title">
                      //         <span className="title">Today</span>
                      //     </div>
                      // </li> :

                      <li key={key} className={msg.userType === "sender" ? "right" : ""}>
                        <div className="conversation-list">

                          <div className="chat-avatar">
                            {msg.userType === "sender" ? <div className="chat-user-img align-self-center">
                              <div className="avatar-xs">
                                <span className="avatar-title rounded-circle bg-soft-primary text-primary">
                                  {"S"}
                                </span>
                              </div>
                            </div> :

                              <div className="chat-user-img align-self-center">
                                <div className="avatar-xs">
                                  <span className="avatar-title rounded-circle bg-soft-primary text-primary">
                                    {"AI"}
                                  </span>
                                </div>
                              </div>

                            }
                          </div>

                          <div className="user-chat-content">
                            <div className="ctext-wrap">
                              <div className="ctext-wrap-content">
                                <p className="mb-0">
                                  {msg.message}
                                </p>

                                <p className="chat-time mb-0"><i className="ri-time-line align-middle"></i> <span className="align-middle">{msg.time}</span></p>
                              </div>

                            </div>
                            {/* {
                                                        <div className="conversation-name">{"Patricia Smith"}</div>
                                                    } */}
                          </div>
                        </div>
                      </li>
                    )
                  }
                </ul>
              </SimpleBar>

              <ChatInput
                onaddMessage={addMessage}
                isDrag={isDrag}
                setDrag={setDrag}
              />

            </div>
        </Col>

      </Row>
    </Provider>
  );
});

export default VideocallIndex;